<template>
  <div v-title data-title="分享信息">
    <div class="showtitle">
      <p style="padding-top:20px;color:#292929;font-size:1.6rem" v-if="formset.ShareTitle!=''">
        <img
          style="width:25px;margin-left:10px;vertical-align:middle"
          src="../../assets/img/pengyou.png"
        />朋友圈标题
      </p>
      <div  @click="clicktocopy()"
          id="copyBtn"
          data-clipboard-action="copy"
          data-clipboard-target="#target" class="titleinfo" v-if="formset.ShareTitle!=''">
        <p style id="target">{{formset.ShareTitle}}</p>
        <div style="height:70px"></div>
        <!-- <div
          @click="clicktocopy()"
          class="copy"
          id="copyBtn"
          data-clipboard-action="copy"
          data-clipboard-target="#target"
        >
          <img
            src="../../assets/img/wenan.png"
            style="width:25px;margin-left:10px;vertical-align:middle"
          />
          <span
            style="margin-left:2px;vertical-align:middle;color:#797979;margin-bottom:10px"
          >复制分享标题</span>
        </div> -->
      </div>

      <p :class="formset.ShareTitle!=''?'press':'presstop'">
        <img
          style="width:25px;margin-left:10px;vertical-align:middle"
          src="../../assets/img/haibao.png"
        />分享海报
        <span class="save">长按海报保存</span>
      </p>
      <div style="text-align:center">
        <img
          style="width:70%;margin-top:10px"
          v-bind:src="'data:image/png;base64,'+formset.PosterBase64"
        />
      </div>

      <p class="press">
        <img
          style="width:25px;margin-left:10px;vertical-align:middle"
          src="../../assets/img/tupian.png"
        />分享图片
        <span class="save">长按图片保存</span>
      </p>
      <div class="border">
        <div style="text-align:center;margin-top:10px;">
          <img
            style="width:92%;margin-bottom:5px;"
            :src="url
      "
            v-for="url in formset.PicUrls"
            :key="url"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Toast } from "we-vue";
import Vue from "vue";
import thumb from "../../assets/logo.png";
import { Dialog } from "we-vue";
import wx from "weixin-js-sdk";
import { debug } from "util";
import Clipboard from "clipboard";

export default {
  name: "showtitle",
  data: function() {
    return {
      formset: { ShareTitle: "" },
      info: {}
    };
  },
  created: function() {
    var url = window.location.href;
    var info = this.GetRequest(url)["info"];
    if (info != undefined) {
      this.info = JSON.parse(info);
      this.init();
    }
  },
  mounted: function() {},
  methods: {
    init: function() {
      this.$store.commit("showLoading");
      this.$http
        .post(
          this.GLOBAL.BASE_URL + "api/tbproduct/generateposterandshareinfo",
          this.info,
          {
            emulateJSON: true
          }
        )
        .then(function(d) {
          var rep = JSON.parse(d.bodyText);
          if (rep.Success) {
            this.formset = rep.Data;
          } else {
            Toast.fail(rep.Message);
          }
          this.$store.commit("hideLoading");
        });
    },
    clicktocopy: function() {
      var clipboard = new Clipboard("#copyBtn");
      clipboard.on("success", function(e) {
        Toast.success("复制成功");
        e.clearSelection();
      });
      return;
    }
  }
};
</script>

<style>
.showtitle {
  margin-left: 3%;
  margin-right: 3%;
}
.titleinfo {
  border: 1px solid rgb(233, 227, 227);
  border-radius: 8px;
  margin-top: 5px;
  width: 100%;
  font-size: 1.6rem;
}
.copy {
  margin-top: -45px;
  width: 180px;
  background: #ececec;
  border-radius: 15px;
  height: 30px;
  font-size: 1.4rem;
  float: right;
  margin-right: 5px;
}
#target {
  margin-top: 10px;
  margin-left: 5px;
  font-size: 1.3rem;
}
.press {
  margin-top: 40px;
  color: #292929;
  font-size: 1.6rem;
}

.presstop {
  padding-top: 20px;
  color: #292929;
  font-size: 1.6rem;
}
.border {
  border: 1px solid rgb(233, 227, 227);
  border-radius: 8px;
  margin-top: 5px;
  margin-bottom: 20px;
  min-height: 200px;
}

.save {
  float: right;
  margin-right: 3%;
  font-size: 1.6rem;
  color: #bfbfbf;
}
</style>






// WEBPACK FOOTER //
// src/components/showtitle/showtitle.vue